import { InfoCircleOutlined } from '@ant-design/icons';
import {
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Tooltip,
  Typography,
} from 'antd';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import CurrentUserStore from 'stores/CurrentUserStore';
import ShopStore from 'stores/ShopStore';

import { RolesOptions } from 'stores/Classes/UserObject';
import { formatPhoneNumberWhileTyping } from 'v3/utils/formaters';
import FormCheckbox from './common/FormCheckbox';

const AddUserForm = ({ form }) => {
  useEffect(() => {
    if (CurrentUserStore.user.role === 'admin' && !ShopStore.loaded) {
      ShopStore.getShops();
    }
  }, []);

  const shopsData = Array.from(ShopStore.data.values());

  return (
    <Form
      form={form}
      layout="vertical"
      initialValues={{
        sendLoginCredentials: false,
        printLoginCredentials: false,
      }}
    >
      <Row gutter={[10, 10]}>
        <Col xs={12} sm={12}>
          <Form.Item
            name="firstName"
            label="First Name"
            rules={[{ required: true, message: 'Please enter the First Name' }]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col xs={12} sm={12}>
          <Form.Item
            name="lastName"
            label="Last Name"
            rules={[{ required: true, message: 'Please input the Last Name' }]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={[10, 10]}>
        <Col xs={12} sm={12}>
          <Form.Item
            name="email"
            label="Email/Username"
            rules={[
              { required: true, message: 'The email/username is required' },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col xs={12} sm={12}>
          <Form.Item
            label="Phone Number"
            name="phone"
            rules={[
              {
                pattern: /^\d{10}$/,
                message: 'Please enter a valid phone number',
              },
            ]}
          >
            <InputNumber
              style={{ width: '100%' }}
              controls={false}
              maxLength={14}
              addonBefore={<Typography.Text>+1</Typography.Text>}
              formatter={(value) => formatPhoneNumberWhileTyping(value)}
              parser={(value) => value.replace(/[^0-9]/g, '')}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={[10, 10]}>
        <Col xs={12} sm={12}>
          <Form.Item
            name="fleet"
            label="Fleet"
            rules={[{ required: true, message: 'Please select a fleet' }]}
          >
            <Select
              placeholder="Select a fleet"
              style={{ width: '100%' }}
              allowClear
              options={shopsData.map(({ id, name }) => ({
                value: id,
                label: name,
              }))}
              showSearch
              filterOption={(input, option) =>
                option?.label?.toLowerCase().includes(input.toLowerCase())
              }
            />
          </Form.Item>
        </Col>
        <Col xs={12} sm={12}>
          <Form.Item
            name="role"
            label="Role"
            rules={[{ required: true, message: 'Please select a role' }]}
          >
            <Select
              placeholder="Select a role"
              allowClear
              style={{ width: '100%' }}
              options={RolesOptions.map(({ id, name }) => ({
                value: id,
                label: name,
              }))}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={[10, 10]}>
        <Col xs={12} sm={12}>
          <Form.Item
            name="password"
            label={
              <span>
                Set Password&nbsp;
                <Tooltip title="If a username is used, the password can be edited from the user's profile page if they forget it.">
                  <InfoCircleOutlined />
                </Tooltip>
              </span>
            }
            rules={[{ required: true, message: 'The password is required' }]}
          >
            <Input type="password" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={[0, 10]}>
        <Col
          xs={24}
          sm={24}
          style={{ marginBottom: '0px', paddingBottom: '0px' }}
        >
          <FormCheckbox
            name="sendLoginCredentials"
            title="Send login credentials and instructions to the phone number provided"
          />

          <FormCheckbox
            name="printLoginCredentials"
            title="Print login credentials and instructions"
          />
        </Col>
      </Row>
    </Form>
  );
};

AddUserForm.propTypes = {
  form: PropTypes.object,
};

export default AddUserForm;
